import React, { useState, useEffect } from 'react';
import './../../entrydoor.css';

const Transom = ({ value, onChange, label = 'Transom:', childs = [], disabled = false }) => { // Set default value for childs
    const defaultValue = value || 'None';
    const [selectedTransom, setSelectedTransom] = useState(defaultValue);

    const visibleShapes = ["Rectangle", "Ellipse"];

    // Call onChange once on mount if value is not provided
    useEffect(() => {
        if (!value) {
            onChange(defaultValue);
        }
    }, []); // empty deps to run only once
    

    const handleTransomChange = (e) => {
        const newValue = e.target.value;
        setSelectedTransom(newValue);
        onChange(e.target.value);

        // Dynamically fetch and modify styles for dependent controls if any exist
        if (Array.isArray(childs) && childs.length > 0) {
            childs.forEach((childId) => {
                const element = document.getElementById(childId);
                if (element) {
                    element.style.display = visibleShapes.includes(newValue) ? "block" : "none";
                    const label = element.previousElementSibling; // Fetch the label, if present
                    if (label) {
                        label.style.display = visibleShapes.includes(newValue) ? "block" : "none";
                    }
                }
            });
        }

        if (newValue  === "None") {
            const element1 = document.getElementById("LiteCollection");
            if (element1) {
                element1.style.display = "none";
                const label1 = element1.previousElementSibling;
                if (label1) {
                    label1.style.display = "none";
                }
            }
            const element2 = document.getElementById("LiteCollectionData");
            if (element2) {
                element2.style.display = "none";
                const label2 = element2.previousElementSibling;
                if (label2) {
                    label2.style.display = "none";
                }
            }
            const element3 = document.getElementById("TransomOption");
            if (element3) {
                element3.style.display = "none";
                const label3 = element3.previousElementSibling;
                if (label3) {
                    label3.style.display = "none";
                }
            }
            const element4 = document.getElementById("CasingSize");
            if (element4) {
                element4.style.display = "none";
                const label4 = element4.previousElementSibling;
                if (label4) {
                    label4.style.display = "none";
                }
            }
        }
    };

    return (
        <div className="a-container"> 
            <label disabled={disabled} htmlFor="Transom">{label}</label>
            <select
                disabled={disabled}
                id="Transom"
                value={selectedTransom}
                onChange={handleTransomChange}
            >
              <option value="None">{selectedTransom === "None" ? "None ✔" : "None"}</option>
              <option value="Rectangle">{selectedTransom === "Rectangle" ? "Rectangle ✔" : "Rectangle"}</option>
              <option value="Ellipse">{selectedTransom === "Ellipse" ? "Ellipse ✔" : "Ellipse"}</option>
              <option value="Half-Round">{selectedTransom === "Half-Round" ? "Half-Round ✔" : "Half-Round"}</option>
              <option value="CamberedTop">{selectedTransom === "CamberedTop" ? "Cambered Top ✔" : "Cambered Top"}</option>
              <option value="DoubleTransom">{selectedTransom === "DoubleTransom" ? "Double Transom ✔" : "Double Transom"}</option>

            </select>
        </div>
    );
};

export default Transom;
